
import { defineComponent, PropType } from "vue";
export default defineComponent({
	emits: ["update:visible", "cancel", "confirm", "closeVisible"],
	props: {
		/**
		 * 标题
		 */
		title: {
			type: String,
			default: "",
		},

		/**
		 * 宽度
		 */
		width: {
			type: [String, Number],
			default: "30%",
		},

		/**
		 * 窗口显示
		 */
		visible: {
			type: Boolean,
			default: false,
		},

		/**
		 *
		 */
		bodyNoPadding: {
			type: Boolean,
			default: false,
		},

		/**
		 * 按钮加载
		 */
		loading: {
			type: Boolean,
			default: false,
		},

		/**
		 * 宽度自适应
		 */
		maxContent: {
			type: Boolean,
			default: false,
		},

		/**
		 * 是否显示footer
		 */
		footer: {
			type: Boolean,
			default: true,
		},

		/**
		 * 按钮文本配置
		 */
		content: {
			type: Array as PropType<string[]>,
			default: (): string[] => [],
		},

		/**
		 * 窗口关闭前的回调
		 */
		beforeClose: {
			/* eslint-disable */
			type: Function as PropType<() => void>,
			default: () => {
				return () => {};
			},
		},
	},

	setup(props, ctx) {
		/**
		 * 窗口关闭前执行回调函数
		 */
		const dialogBeforeClose = () => {
			props.beforeClose();
			ctx.emit("update:visible", false);
			ctx.emit("closeVisible", false);
		};

		/**
		 * 点击取消
		 */
		const cancel = () => {
			ctx.emit("update:visible", false);
			ctx.emit("cancel");
		};

		/**
		 * 点击确认
		 */
		const confirm = () => {
			ctx.emit("confirm");
		};

		return {
			dialogBeforeClose,
			cancel,
			confirm,
		};
	},
});
